import { Button, Col, Modal, Row, Spin } from 'hljd'
import React, { Component } from 'react'
import { areaList } from './constant'
import { GlobalItem, Item } from './Item'
import styles from './style.module.less'

export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      uploading: false,
      areaHeight: 350,
      selectKey: '',
      selectList: [],
      unsign: [],
      stage: [],
      check: [],
      detail: []
    }
  }

  initData() {
    const {
      initValue = {
        unsign: [],
        stage: [],
        check: [],
        detail: []
      }
    } = this.props

    const { unsign = [], stage = [], check = [], detail = [] } = initValue

    this.setState({
      unsign,
      stage,
      check,
      detail
    })
  }

  setArea(name, list) {
    this.setState({ [name]: list })
  }

  setSpin(state) {
    this.setState({
      uploading: state
    })
  }

  selectItem(item, has) {
    let list = this.state.selectList.slice(0)

    if (has) {
      list = list.filter(e => {
        if (e?.id && item?.id) {
          return e?.id !== item?.id
        } else if (e?.uid && item?.uid) {
          return e?.uid !== item?.uid
        } else {
          return e?.url !== item?.url
        }
      })
    } else {
      list.push(item)
    }
    this.setState({
      selectList: list
    })
  }

  setTargetKeyItems(tarkey, curKey) {
    const { selectList } = this.state
    const tarList = this.state[tarkey].slice(0)
    const curList = this.state[curKey].slice(0)
    const newTarList = tarList.concat(selectList)
    const newCurList = curList.filter(
      item =>
        !selectList.some(e => {
          if (e?.id && item?.id) {
            return e?.id === item?.id
          } else if (e?.uid && item?.uid) {
            return e?.uid === item?.uid
          } else {
            return e?.url === item?.url
          }
        })
    )

    this.setState({
      [tarkey]: newTarList,
      [curKey]: newCurList,
      selectList: []
    })

    if (selectList.length === curList.length) {
      this.setState({
        selectKey: ''
      })
    }
  }

  toggleMode(isSelected, selectKey) {
    this.setState({
      selectKey: isSelected ? selectKey : '',
      selectList: []
    })
  }

  getResultData() {
    const { unsign, stage, check, detail } = this.state
    return { unsign, stage, check, detail }
  }

  componentDidMount() {
    const ch = document.documentElement.clientHeight
    const remain = ch - 417
    this.setState({
      areaHeight: remain > 350 ? remain : 350
    })

    this.initData()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.initData()
    }
  }

  render() {
    const {
      title = '上传婚礼现场图',
      width = 994,
      visible = false,
      max = 50,
      maxSize = 10,
      maxHeight = 8192,
      maxWidth,
      onSave = () => {},
      onCancel = () => {}
    } = this.props

    const {
      unsign,
      stage,
      check,
      detail,
      areaHeight,
      selectKey,
      selectList
    } = this.state

    const areaData = { stage, check, detail }
    const remain = max - unsign.concat(stage, check, detail).length
    const initSortUploadParams = {
      maxSize,
      maxHeight,
      maxWidth
    }

    const saveHandler = () => {
      onSave(this.getResultData())
    }

    const cancelHandler = () => {
      onCancel(this.getResultData())
    }

    const limitText =
      '2. 支持JPG、PNG和BMP等大部分格式，图片' +
      (maxWidth ? `宽度在${maxWidth}像素以下，` : '') +
      (maxHeight ? `高度在${maxHeight}像素以下，` : '') +
      `图片大小不可大于${maxSize}M；`

    return (
      <Modal
        title={title}
        width={width}
        visible={visible}
        onCancel={cancelHandler}
        footer={
          <Row>
            <Col flex="auto" style={{ textAlign: 'left' }}>
              <span style={{ lineHeight: '32px' }}>
                还可以上传{remain}张图片，你可以拖拽调整图片位置
              </span>
            </Col>
            <Col>
              <Button type="default" onClick={cancelHandler}>
                取消
              </Button>
              <Button
                type="primary"
                onClick={saveHandler}
                disabled={this.state.uploading}
              >
                保存
              </Button>
            </Col>
          </Row>
        }
      >
        <Spin delay={300} spinning={this.state.uploading} tip="图片正在上传...">
          <div className={styles.info}>
            <p>1. 请勿在图片添加任何文字、水印、logo，以免审核不通过；</p>
            <p>
              <span>{limitText}</span>
            </p>
            <p>3. 支持多张图片同时上传，支持在本弹框拖拽调整顺序。</p>
          </div>
          <div className={styles.ctrlPanel} style={{ height: areaHeight }}>
            {unsign.length > 0 && (
              <GlobalItem
                key={'unsign'}
                title={'请设置图片的婚礼区域'}
                value={unsign}
                mask={selectKey && selectKey !== 'unsign'}
                selected={selectList}
                selectMode={selectKey === 'unsign'}
                onChange={list => this.setArea('unsign', list)}
                toggleMode={e => this.toggleMode(e, 'unsign')}
                onSelect={(e, has) => this.selectItem(e, has)}
                onAreaSet={e => this.setTargetKeyItems(e, 'unsign')}
              />
            )}
            {areaList.map(({ title, key }) => (
              <Item
                key={key}
                keyName={key}
                title={title}
                mask={selectKey && selectKey !== key}
                selectMode={selectKey === key}
                value={areaData[key]}
                selected={selectList}
                onChange={list => this.setArea(key, list)}
                onLoad={e => this.setSpin(!e)}
                toggleMode={e => this.toggleMode(e, key)}
                onSelect={(e, has) => this.selectItem(e, has)}
                onAreaSet={e => this.setTargetKeyItems(e, key)}
                max={remain}
                {...initSortUploadParams}
              />
            ))}
          </div>
        </Spin>
      </Modal>
    )
  }
}
